import {WikiGroup, WikiItem} from './../../../wiki/models/wiki.model';
export interface WikiState {
  wikiList: WikiGroup[];
  loading: boolean;
  wikiItem: WikiItem | null;
}

export const initialWikiState: WikiState = {
  wikiList: [],
  loading: false,
  wikiItem: null,
};
